module.exports = __webpack_public_path__ + "img/2_full.58d65866.jpg";